import {useQuery} from "@tanstack/react-query";
import {getUserLastConnection} from "../services/account/getUserLastConnection.service";

const useGetUserLastConnection = () => {
  return useQuery({
    queryKey: ["userLastConnection"],
    queryFn: getUserLastConnection,
    select: response => {
      return response?.data;
    },
  });
};

export default useGetUserLastConnection;
